<template>
  <div>
    <ul class="hotlist">
      <li class="title" @click="goNewList('')">
        <span>专题</span>
        <img src="/static/img/icn_zhuanti.png" alt=""/>
      </li>
      <!-- <li v-for="(item,index) in infos" :key="item.id" @click="goNewList(item.uuid)" :class="getItemClass(index)"> -->
      <li class="ggw">
        <!-- <img :src="`${IP_TEST}/uploads/${item.picsrc}`" alt="" /> -->
      <div id="demo" style="overflow: hidden; height: 120px; width: 100%; clear:both;">
				<table align="center" border="0" cellpadding="0" cellspacing="0" width="98%">
					<tbody>
						<tr>
							<td id="demo1" valign="middle">
								<table border="0" cellspacing="0" cellpadding="0">
									<tbody>
										<tr>
											<td v-for="(adv ,index) in infos" :key="index">
                        <a>
													<div class="pic"
                          @click="goNewList(adv.uuid,adv.url)"
														:style="`background-image: url(${IP_TEST}/uploads/${adv.picsrc})`">
													</div>
												</a>
                      </td>
										</tr>
									</tbody>
								</table>
							</td>
							<td id="demo2" valign="top">
								<table border="0" cellspacing="0" cellpadding="0">
									<tbody>
										<tr>
										<td v-for="(adv ,index) in infos" :key="index">
                        <a >
													<div class="pic" 
                           @click="goNewList(adv.uuid,adv.url)"
														:style="`background-image: url(${IP_TEST}/uploads/${adv.picsrc})`">
													</div>
												</a>
                      </td>
										</tr>
									</tbody>
								</table>

							</td>
						</tr>
					</tbody>
				</table>
			</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import { getNewsViews } from '@/request/get'
export default {
  name: "Subject",
  components: {
  },
  data() {
    return {
      IP_TEST,
      infos: [],
      plateIdInfo:''
    }
  },
  created() {
     this.getNewsViews();
    
  },
  mounted() {
    this.$nextTick(function(){
           function srcollpic(x, y, z) {
              var speed = 30
              var demo2 = document.getElementById(x);
              var demo1 = document.getElementById(y);
              var demo = document.getElementById(z);
              demo2.innerHTML = demo1.innerHTML;

              function Marquee() {
                if (demo.scrollLeft == demo1.offsetWidth-demo.offsetWidth) demo.scrollLeft = demo2.offsetWidth;
                demo.scrollLeft++;
              }

              var MyMar = setInterval(Marquee, speed)
              demo.onmouseover = function () { clearInterval(MyMar) }
              demo.onmouseout = function () { MyMar = setInterval(Marquee, speed) }
            }
            
            srcollpic('demo2', 'demo1', 'demo')
        })
  },
  methods: {
    async getNewsViews() {
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == '专题');
      this.plateIdInfo = plate[0].uuid;
      let result = await getNewsViews(this.plateIdInfo, 1, 4);
      result = result.data.concat(result.data);
      this.infos = result || [];
      this.infos = this.infos.reverse();
    },
    goNewList(uuid,url) {
      if(url){
        window.open(url);
        return;
      }
      if (uuid) {
        this.$router.push('/news/info/' + this.plateIdInfo + '/' + uuid);
      } else {
        this.$router.push('/news/views/' + this.plateIdInfo + '/' + uuid);
      }
    },
    getItemClass(index){
      if (index == 0) {
        return 'bg_one'
      }
      if (index == 1) {
        return 'bg_two'
      }
      if (index == 2) {
        return 'bg_three'
      }
      if (index == 3) {
        return ''
      }
    }
  }
};
</script>
<style scoped>
.hotlist {
  position: relative;
  width: 1300px;
  height: 103px;
  display: flex;
  justify-content: start;
}

.hotlist>li {
  position: relative;
  width: 1152px;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  overflow: hidden;
}
.hotlist>li.title{
  width: 49px;
  margin-right: 12px;
}
.hotlist>li.title>span{
  position: absolute;
  left: 14px;
  width: 20px;
  height: 44px;
  font-size: 20px;

  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
      font-weight: 900;
  z-index: 1;
}
.hotlist>li.title>img {
  position: absolute;
  border-radius:6px;
}
.hotlist>li.bg_one,.hotlist>li.bg_two{
  margin-right: 17px;
}
.hotlist>li.bg_three {
  margin-right: 15px;
}
.ggw{
  margin:auto;
	margin-bottom: 15px;
  width: 1300px;
}
.pic{
	width: 288px;
	height: 120px;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	margin-right: 12px;
}
</style>
